module.exports = __webpack_public_path__ + "media/images/icon-mybenfits-app-steps-0861ddd8824be1868639eb84b26e099e.png";